<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <!-- Start:: Is Active -->
            <!-- <div class="col-lg-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.for_all')"
                v-model="data.all"
                color="success"
              ></v-checkbox>
            </div> -->
            <!-- End:: Is Active -->
            <div class="col-lg-6">
              <v-h4 style="color: #cd201f" class="mb-2">إرسال الي</v-h4>
              <v-radio-group v-model="data.type" row>
                <v-radio label="العملاء" value="client"></v-radio>
                <v-radio label="المتاجر" value="store"></v-radio>
                <v-radio label="السائقين" value="driver"></v-radio>
              </v-radio-group>
            </div>
            <div class="col-lg-6" v-if="data.type == 'client'">
              <v-h4 style="color: #cd201f" class="mb-2">نوع الإشعار</v-h4>
              <v-radio-group v-model="data.notify_type" row>
                <v-radio label="عام" value="general"></v-radio>
                <v-radio label="فتح متجر" value="open_restaurant"></v-radio>
                <v-radio label="فتح منتج" value="open_meal"></v-radio>
              </v-radio-group>
            </div>

            <!-- v-if="!data.all" -->
            <div
              class="col-lg-12 py-0"
              v-if="data.notify_type != 'general' && data.type == 'client'"
            >
              <div
                class="input_wrapper top_label"
                v-if="data.notify_type == 'open_meal'"
              >
                <label class="form-label">المتاجر</label>
                <multiselect
                  v-model="data.store"
                  :options="stores"
                  @input="getMeals()"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                >
                </multiselect>
              </div>
              <div class="input_wrapper top_label">
                <label class="form-label">{{
                  {
                    open_restaurant: "المتجر",
                    open_meal: "المنتج",
                  }[data.notify_type]
                }}</label>
                <multiselect
                  v-model="data.notify_id"
                  :options="data.notify_type == 'open_meal' ? products : stores"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                >
                </multiselect>
              </div>
            </div>
            <!-- v-if="!data.all" -->
            <div class="col-lg-12 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">{{
                  {
                    store: "المتاجر",
                    client: "العملاء",
                    driver: "السائقين",
                  }[data.type] +
                  " " +
                  `(في حال ما تم الاختيار يتم الارسال الي كل ${
                    {
                      store: "المتاجر",
                      client: "العملاء",
                      driver: "السائقين",
                    }[data.type]
                  })`
                }}</label>
                <multiselect
                  v-model="data.user_list"
                  :options="clients"
                  :loading="loadingUsers"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                  multiple
                >
                </multiselect>
              </div>
            </div>
            <!-- Start:: Title -->
            <div class="col-lg-12 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.title"
                />
                <label for="name_input" class="form-label">{{
                  $t("forms.labels.title")
                }}</label>
              </div>
            </div>
            <!-- End:: Title -->

            <!-- Start:: Ar desc -->
            <div class="col-lg-12 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">{{
                  $t("forms.labels.desc")
                }}</label>
                <textarea
                  v-model="data.desc"
                  class="form-control"
                  rows="5"
                ></textarea>
              </div>
            </div>
            <!-- End:: Ar desc -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button
            class="button_style_1"
            :class="btnIsLoading ? 'disabled' : ''"
          >
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.notifications.title"),
          disabled: false,
          href: "/notifications/all-notifications",
        },
        {
          text: this.$t("breadcrumb.notifications.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      loadingUsers: false,

      // ========== create_data
      data: {
        user_list: [],
        title: null,
        desc: null,
        type: "client",
        notify_type: "general",
        notify_id: null,
      },
      clients: [],
      types: [
        {
          id: "all",
          name: "الجميع",
        },
        {
          id: "client",
          name: "عميل",
        },
        {
          id: "store",
          name: "متجر",
        },
        {
          id: "restaurant",
          name: "مطعم",
        },
        {
          id: "rental",
          name: "تأجير",
        },
      ],
      products: [],
      stores: [],
    };
  },
  watch: {
    "data.type"(value) {
      this.data.user_list = [];
      this.getUsers(value);
    },
    "data.notify_type"() {
      this.data.notify_id = null;
    },
  },

  methods: {
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (this.data.type == "user" && this.data.clients.length == 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.clients"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.title"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.desc"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.type == "store") {
        submit_data.append("user_type", "restaurant");
      } else {
        submit_data.append("user_type", this.data.type);
      }
      if (this.data.type.length) {
        this.data.user_list.forEach((item, index) => {
          submit_data.append(`user_list[${index}]`, item.id);
        });
      }
      if (this.data.type == "client") {
        submit_data.append("notify_type", this.data.notify_type);
      }
      if (
        (this.data.notify_type == "open_meal" ||
          this.data.notify_type == "open_restaurant") &&
        this.data.type == "client"
      ) {
        if (this.data.notify_id) {
          submit_data.append("notify_id", this.data.notify_id.id);
        }
      }
      submit_data.append("title", this.data.title);
      submit_data.append("body", this.data.desc);
      submit_data.append("type", this.data.type);

      this.$axios({
        method: "POST",
        url: "notification",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/notifications/all-notifications" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // ====== Clients / Stores / Drivers
    getUsers(type) {
      const userType = type || this.data.type || "client";
      this.loadingUsers = true;
      this.clients = [];
      this.$axios({
        method: "GET",
        url: `${userType}_not_paginated`,
      })
        .then((res) => {
          this.clients = (res.data.data || []).map((item) => {
            return {
              id: item.id,
              name: item.full_name || item.name || item.title || "",
            };
          });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingUsers = false;
        });
    },

    getStores() {
      this.$axios({
        method: "GET",
        url: `store_not_paginated`,
      }).then((res) => {
        this.stores = (res.data.data || []).map((item) => {
          return {
            id: item.id,
            name: item.full_name || item.name || "",
          };
        });
      });
    },

    getData(type) {
      this.getUsers(type);
      this.getStores();
    },

    getMeals() {
      this.$axios({
        method: "GET",
        url: `meal_not_paginated`,
        params: {
          user_id: this.data.store.id,
        },
      }).then((res) => {
        this.products = res.data.data.map((item) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
      });
    },
  },

  created() {
    this.getData(this.data.type);
  },
};
</script>

<style lang="scss">
.productRow {
  border: 1px solid #339989;
  border-radius: 15px;
  padding: 10px 10px 20px 10px;
  margin-bottom: 20px;

  .detail {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
    .detail_show {
      border: 1px solid #339989;
      padding: 10px;
      flex-grow: 1;
      border-radius: 15px;
      position: relative;
      min-height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .rate {
        color: gray;
        position: absolute;
        top: 5px;
        left: 5px;
        font-size: 13px;

        span {
          color: yellow;
        }
      }

      .image {
        img {
          max-height: 50px;
        }
      }

      .color,
      .size {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .image {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .key {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
